var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('validation-provider',{attrs:{"name":"valor","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('vuetify-money',{attrs:{"error-messages":errors,"label":'Valor Inicial do Caixa',"properties":{
            'persistent-hint': true,
            'prepend-icon': 'mdi-currency-usd',
            required: true,
          }},model:{value:(_vm.value.valor_em_caixa),callback:function ($$v) {_vm.$set(_vm.value, "valor_em_caixa", $$v)},expression:"value.valor_em_caixa"}})]}}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }